import Icon from '../../marker/rectangle/Rectangle';
import EwsStatusColor from './EwsStatusColor';

const EwsColor = (txt) => {
  let color;
  let icon;
  const txtIcon = Icon;
  const [zero, one, two] = EwsStatusColor;

  if (txt === 'อพยพ' || txt === 'evacuate') {
    color = zero;
    icon = txtIcon.grey;
  } else if (txt === 'เตือนภัย' || txt === 'warning') {
    color = one;
    icon = txtIcon.grey;
  } else if (txt === 'เฝ้าระวัง' || txt === 'watch') {
    color = two;
    icon = txtIcon.blue;
  }
  return { color, icon };
};

export default EwsColor;
